export const METODO_LIMPEZA_OUTROS = 'Outros';

export const OPCOES_METODO_LIMPEZA = [
	'Escovagem',
	'Jato de ar',
	'Jato de água',
	'Raspagem',
	METODO_LIMPEZA_OUTROS,
];

const REGEX_METODO_LIMPEZA_OUTROS = /^Outros\s*\((.+)\)\s*$/i;

export const extrairMetodoLimpezaOutros = (metodo: any): string => {
	const match = String(metodo ?? '').match(REGEX_METODO_LIMPEZA_OUTROS);
	return match ? match[1].trim() : '';
};

export const normalizarMetodoLimpezaParaFormulario = (metodo: any) => {
	const metodoTexto = String(metodo ?? '').trim();
	if (!metodoTexto) {
		return { metodo: '', outros: '' };
	}

	const outros = extrairMetodoLimpezaOutros(metodoTexto);
	if (outros) {
		return { metodo: METODO_LIMPEZA_OUTROS, outros };
	}

	if (OPCOES_METODO_LIMPEZA.includes(metodoTexto)) {
		return { metodo: metodoTexto, outros: '' };
	}

	return { metodo: METODO_LIMPEZA_OUTROS, outros: metodoTexto };
};

export const formatarMetodoLimpezaParaJson = (metodo: any, outros: any) => {
	const metodoTexto = String(metodo ?? '').trim();
	const outrosTexto = String(outros ?? '').trim();

	if (metodoTexto !== METODO_LIMPEZA_OUTROS) {
		return metodoTexto;
	}

	return outrosTexto ? `${METODO_LIMPEZA_OUTROS} (${outrosTexto})` : METODO_LIMPEZA_OUTROS;
};

export const juntarResponsaveisLimpeza = (itens: Array<Record<string, any> | null | undefined>): string => {
	const nomes: string[] = [];

	itens.forEach((item) => {
		const nome = String(item?.responsavel ?? item?.Responsavel ?? '').trim();
		if (nome && !nomes.includes(nome)) {
			nomes.push(nome);
		}
	});

	return nomes.join(', ');
};
